import { IProvidedService } from "services";
import { Constants, Helpers } from "utils";

export const makeAppointment = async (
  service: IProvidedService,
  clinicId: number,
  providerId: number,
  patientId: number | null,
  calendarId: string,
  serviceId: number,
  date: Date | null,
  slot: string | null,
  reason: string | null,
  healthGoals: number[],
  walkIn: boolean,
  qiosk?: boolean,
  onDone?: (state: boolean) => void,
  onError?: (message?: string) => void
) => {
  // retrieve clinic info
  const clinic = await service.clinic.findById(clinicId);

  // retrieve provider info
  const provider = await service.provider.findById(providerId);

  // retrieve patient info
  const patient = await service.patient.find(patientId);

  // insert the event (google calendar)
  const [id, st, en] = await service.google.insert(
    calendarId,
    serviceId,
    date,
    slot,
    Constants.APPOINTMENT_DURATION,
    clinic,
    Array.isArray(patient) ? patient[0] : patient,
    provider,
    reason,
    walkIn
  );

  if (id) {
    // insert the appointment (qubehub api)
    const [status, response] = await service.appointment.create(calendarId, id, serviceId, st, reason ?? "", healthGoals, patientId, walkIn, qiosk ?? false);

    if (response) {
      onDone && onDone(true);
    } else {
      await service.google.delete(calendarId, id);
      onError && onError();
    }
  } else {
    onError && onError();
  }
};
